/**
 * Idoneità delle icone dei metodi di pagamento per mercato.
 *
 * Stripe NON espone un'API per pilotare le icone "marketing", quindi
 * l'idoneità è una mappa curata, modificabile qui in un unico punto.
 * Il segnale di mercato è:
 *   - lang: la lingua/dominio corrente (un dominio per mercato, vedi memoria
 *           "domini-per-lingua": it→IT, fr→FR, de→DE, en→internazionale)
 *   - countryId: l'id nazione interno Ribola quando disponibile
 *                (order.selectedCountryRealId; 36 = Italia)
 *
 * Le icone non elencate in ICON_ELIGIBILITY sono sempre visibili.
 */

// id nazione interno Ribola
const ITALY_COUNTRY_ID = 36;

// mercati UE (domini/lingue) in cui ha senso mostrare l'addebito SEPA
const EU_LANGS = ["it", "fr", "de"];

const isItaly = ({ lang, countryId }) =>
  lang === "it" || countryId === ITALY_COUNTRY_ID;

// Regole per nome file icona. Restituiscono true se l'icona va mostrata.
const ICON_ELIGIBILITY = {
  // Satispay: solo mercato Italia
  "satispay.svg": isItaly,
  // Contrassegno: solo Italia (coerente con PaymentDetail, nazione 36)
  "contrassegno.svg": isItaly,
  // Addebito SEPA: solo mercati UE
  "sepa.svg": ({ lang }) => EU_LANGS.includes(lang),
};

// normalizzo la lingua: "it_it"/"IT" -> "it"
const normalizeLang = (lang) =>
  String(lang || "")
    .toLowerCase()
    .replace("_", "")
    .slice(0, 2);

// estraggo il nome file da un eventuale path ("/images/visa.svg" -> "visa.svg")
const fileName = (icon) => String(icon).split("/").pop();

/**
 * Indica se una singola icona è idonea per il mercato corrente.
 * @param {string} icon nome file o path dell'icona
 * @param {{ lang?: string, countryId?: number }} ctx contesto di mercato
 */
export const isPaymentIconEligible = (icon, ctx = {}) => {
  const rule = ICON_ELIGIBILITY[fileName(icon)];
  if (!rule) return true;
  return rule({ lang: normalizeLang(ctx.lang), countryId: ctx.countryId });
};

/**
 * Filtra una lista di icone in base al mercato corrente.
 * @param {string[]} iconFiles
 * @param {{ lang?: string, countryId?: number }} ctx
 */
export const filterPaymentIcons = (iconFiles, ctx = {}) =>
  (iconFiles || []).filter((icon) => isPaymentIconEligible(icon, ctx));

export default { isPaymentIconEligible, filterPaymentIcons };
